<template>
  <v-card>
    <v-card-title class="headline">ダウンロード</v-card-title>
    <v-container>
      <div class="download-image" id="download-image" :style="styleObject">
        <div class="download-graph-title" v-if="showTitle">{{title}}</div>
        <img :src="img" />
        <div class="download-graph-description" v-if="showDescription">{{description}}</div>
      </div>
      <div class="download-graph-header">ダウンロード設定</div>
      <div class="download-option">
        <v-row>
          <v-checkbox
            v-model="showTitle"
            color="#7E6990"
            class="mx-2 mt-0"
            label="タイトルを表示"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="showDescription"
            color="#7E6990"
            class="mx-2 mt-0"
            label="説明文を表示"
            hide-details
          ></v-checkbox>
        </v-row>
      </div>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="#7E6990" outlined dark rounded @click="closeModal">閉じる</v-btn>
      <v-btn color="#7E6990" dark rounded @click="saveImage">ダウンロード</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import domtoimage from "dom-to-image";
export default {
  props: ["img", "title", "description", "openDownloadDialog", "imgWidth"],
  data: function() {
    return {
      showTitle: true,
      showDescription: true,
      styleObject: {
        width: this.imgWidth + 5 + "px"
      }
    };
  },

  methods: {
    close: function() {
      this.$emit("close", { index: this.index });
    },
    changeGraphTitle: function() {
      this.$emit("changeGraphTitle", {
        index: this.index,
        title: this.tmpGraphTitle
      });
    },
    changeGraphDescription: function() {
      this.$emit("changeGraphDescription", {
        index: this.index,
        description: this.tmpGraphDescription
      });
    },
    handlePrint() {
      const canvasEle = this.$el.querySelector("canvas");
      this.tmpImageData = canvasEle.toDataURL("image/png");
    },
    closeModal() {
      this.$emit("close");
    },
    // DOMの画像を保存します
    saveImage() {
      var node = document.getElementById("download-image");
      // 横幅の設定
      // node.style.width = this.imgWidth;
      // node.style.padding = "none";
      // node.style.margin = "none";
      // node.style.border = "none";
      // DOM要素をdomtoimageのtoPNGに渡すと結果がPromiseで返ってくる
      domtoimage
        .toPng(node, {
          bgcolor: "rgb(255,255,255)",
          style: {
            width: this.imgWidth,
            padding: "none",
            margin: "none",
            border: "none"
          }
        })
        .then(function(dataUrl) {
          // dataUrlが返ってくるのでImageを生成し生成した画像を読み込む
          const img = new Image();
          img.src = dataUrl;
          // 読み込みが終わったらダウンロードさせる
          img.onload = () => {
            let downloadEle = document.createElement("a");
            downloadEle.href = img.src;
            downloadEle.download = "canvas.png";
            downloadEle.click();
          };
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.download-graph-title,
.download-graph-description {
  font-size: 16px;
  padding: 2px;
}
.download-graph-header {
  font-size: 20px;
  padding: 4px;
}
.download-image {
  border: solid 2px #e3dfe6;
}
</style>
